import React from "react";
import StayTouch from "../../layout/StayTouch";
import layoutWrapper from "../../components/Hoc/layoutWrapper";
import AnyQuestions from "../../reusable/AnyQuestions";
import TopBanner from "../../reusable/TopBanner";
import GetSimSubNavi from "../../reusable/GetSimSubNavi";
import RechargeSimController from "./RechargeSim";



class RechargeSim extends React.Component {
    render(){
        return(
            <div>
                <TopBanner title="Recharge SIM"/>
                {/*<GetSimSubNavi />*/}
                <RechargeSimController />
                <AnyQuestions />
                <StayTouch />
            </div>
        );
    }
}

export default layoutWrapper(RechargeSim);



// WEBPACK FOOTER //
// ./src/pages/rechargeSim/index.js